import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"
import { useProjectDataStore } from "@state/projectDataStore"
import InfoLayout from "./components/InfoLayout"
import gsap from "gsap"
import InfoLayout2 from "./components/InfoLayout2"

const Info1 = (props: any) => {
  const { info1Data } = useProjectDataStore((s) => ({
    info1Data: s.info1Data,
  }))
  const contentControls = useStore((s) => s.contentControls)

  useEffect(() => {
    gsap.to(".first", {
      autoAlpha: contentControls?.index === 0 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
    gsap.to(".second", {
      autoAlpha: contentControls?.index === 1 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
  }, [contentControls])

  return (
    <Info1Wrapper>
      <InfoLayout2 className="first" info1Data={info1Data?.sections[0]} />
      <InfoLayout className="second" info1Data={info1Data?.sections[1]} />
    </Info1Wrapper>
  )
}

export default Info1

const Info1Wrapper = styled.div`
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: #ede9e3;
  display: flex;

  .second {
    opacity: 0;
  }
`
